// components/notifications/NotificationTypeBadge.tsx

import { TYPE_LABEL, type NotificationType } from '@/lib/types/notifications'
import { cn } from '@/lib/utils'

const TYPE_CLASS: Record<NotificationType, string> = {
  gameweek_start: 'bg-blue-100 text-blue-900 dark:bg-blue-950 dark:text-blue-200',
  gameweek_end: 'bg-blue-100 text-blue-900 dark:bg-blue-950 dark:text-blue-200',
  gameweek_deadline: 'bg-sky-100 text-sky-900 dark:bg-sky-950 dark:text-sky-200',
  transfer_deadline: 'bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200',
  price_change: 'bg-zinc-100 text-zinc-900 dark:bg-zinc-800 dark:text-zinc-200',
  achievement_unlocked: 'bg-purple-100 text-purple-900 dark:bg-purple-950 dark:text-purple-200',
  prize_won: 'bg-emerald-100 text-emerald-900 dark:bg-emerald-950 dark:text-emerald-200',
  payment_received: 'bg-teal-100 text-teal-900 dark:bg-teal-950 dark:text-teal-200',
  system_alert: 'bg-red-100 text-red-900 dark:bg-red-950 dark:text-red-200',
  admin_broadcast: 'bg-indigo-100 text-indigo-900 dark:bg-indigo-950 dark:text-indigo-200',
  token_cup: 'bg-purple-100 text-purple-900 dark:bg-purple-950 dark:text-purple-200',
  membership_incident_commission: 'bg-teal-100 text-teal-900 dark:bg-teal-950 dark:text-teal-200'
}

export function NotificationTypeBadge({ type }: { type: string }) {
  const label = (TYPE_LABEL as Record<string, string>)[type] ?? type
  const klass = (TYPE_CLASS as Record<string, string>)[type] ?? 'bg-zinc-100 text-zinc-700'
  return (
    <span
      className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium', klass)}
    >
      {label}
    </span>
  )
}
